<template>
  <div class="date-wrapper inline-block">
    <div class="mr-10 inline-block ">
      {{ $t('text.chart_date') }}
    </div>
    <span class="date-value mt-5">{{
      userLang.indexOf('en') > -1
        ? moment(date[0]).format('DD MMM YY ') +
          '-' +
          moment(date[1]).format('DD MMM YY ')
        : moment(date[0]).format('DD/MM/YY ') +
          '-' +
          moment(date[1]).format('DD/MM/YY ')
    }}</span>
    <span class="date-picker-module">
      <el-date-picker
        class="w-240"
        v-model="date"
        type="daterange"
        size="small"
        range-separator="to"
        :picker-options="pickerOptions"
        :clearable="false"
        :format="userLang.indexOf('en') > -1 ? 'dd MMM yy' : 'dd/MM/yy'"
        @change="handleDatePickerChange()"
      ></el-date-picker>
    </span>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      moment,
      userLang: 'navigator.language || navigator.userLanguage',
      date: this.$store.state.patient.selectedDateRange,
      pickerMinDate: null,
      day7: 7 * 24 * 3600 * 1000 - 1,
      pickerOptions: {
        onPick: time => {
          if (time.minDate && this.pickerMinDate) {
            this.pickerMinDate = null
          } else if (time.minDate) {
            this.pickerMinDate = time.minDate.getTime()
          }
        },
        disabledDate: time => {
          // only select dates within seven days, and later dates are prohibited
          if (this.pickerMinDate) {
            return (
              time.getTime() > this.pickerMinDate + this.day7 ||
              time.getTime() < this.pickerMinDate - this.day7 ||
              time.getTime() > Date.now() ||
              time.getTime() === this.pickerMinDate
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      }
    }
  },
  watch: {
    '$store.state.patient.selectedDateRange': function() {
      this.date = this.$store.state.patient.selectedDateRange
    }
  },
  methods: {
    handleDatePickerChange() {
      this.$store.commit('patient/SET_SELECTED_DATE_RANGE', this.date)
    }
  }
}
</script>

<style lang="scss" scoped>
.date-value {
  display: none;
}
.date-picker-module {
  display: inline-block;
}
</style>
